<template>
  <b-row class="w-100">
    <b-col md="4">
      <SearchBar class="w-75 pt-2" @getLocations="getLocationsByType" />
    </b-col>
    <b-col md="4">
      <StatusFilter
        v-if="statusFilter"
        class="w-75"
        @getLocations="getLocationsByType"
      />
    </b-col>
    <b-col>
      <CompanyFilter
        v-if="statusFilter"
        class="w-75"
        @getLocations="getLocationsByType"
      />
      <!-- <TypeFilter v-if="shouldToggle" class="w-50" @getLocations="getLocationsByType" /> -->

    </b-col>
  </b-row>
</template>

<script>
import DateFilter from './dateFilter.vue'
import SearchBar from './searchBar.vue'
import CompanyFilter from './companyFilter.vue'
import StatusFilter from './statusFilter.vue'
import UserFilter from './userFilter.vue'
import TypeFilter from './typeFilter.vue'
import { BRow, BCol } from 'bootstrap-vue'
import { mapState } from 'vuex'

export default {
  components: {
    DateFilter,
    SearchBar,
    StatusFilter,
    CompanyFilter,
    BRow,
    BCol,
    TypeFilter,
    UserFilter,
  },
  props: {
    shouldToggle: Boolean,
    statusFilter: {
      default: true,
    },
    companyFilter: {
      default: true,
    },
    userFilter: {
      default: false,
    },
  },
  methods: {
    getLocationsByType() {
      this.$emit('getLocations')
    },
  },
  computed: {
    ...mapState('tableFilters', ['selectedTypeFilter']),
  },
}
</script>
